import angular = require("angular");
import TPL = require("templates");
import {Config} from "../../config";

export class ManageHeaderDirective {

  template = TPL.contentDirectives.manageHeader;
  scope = {
    params: "=params"
  };
  link;

  constructor(session, $routeParams) {
    this.link = (scope, el, attrs) => {
        scope.vm = {
          session: session,
          section: $routeParams.what,

          getUpcomingCount() {
            return scope.params.upcoming;
          },

          getHostedCount() {
            return scope.params.hosted;
          },

          getSavedCount() {
            return scope.params.saved;
          },

          getPastCount() {
            return scope.params.past;
          },

          isOnward() {
            return Config.isOnward;
          }
        };


    }
  }

  static factory() {
    var tmp = (a, b) => new ManageHeaderDirective(a, b);
    tmp.$inject = ["session", "$routeParams"];
    return tmp;
  }

}



/** WEBPACK FOOTER **
 ** ./src/scripts/directives/content/manageHeader.ts
 **/